import { render, staticRenderFns } from "./DialogCreateRemuneracaoProfessorComponent.vue?vue&type=template&id=c6af2102&"
import script from "./DialogCreateRemuneracaoProfessorComponent.vue?vue&type=script&lang=js&"
export * from "./DialogCreateRemuneracaoProfessorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports